import React, { useEffect, useState } from 'react'
import Navbar from '../sections/common/Navbar'
import Footer from '../sections/common/Footer'
import { detailsPageApi } from "../apis/detailsPages/detailsPagesApi";

function TermAndCondition() {
    const [details, setDetails] = useState([]);

    const fetchPrivacyPolicy = async () => {
      const response = await detailsPageApi("terms-and-condition");
      const detailsData = response.data.data.content;
      console.log(detailsData);
      setDetails(detailsData);
    };
  
    useEffect(() => {
      fetchPrivacyPolicy();
    }, []);
    return (
        <div>
            <Navbar />
            <section className="listing-banner">
                <h1>Term And Condition</h1>
            </section>
            <section className="container blog-details-page-location">
                <p>Home / Term And Condition</p>
            </section>

            <section className="container blog-details-page-location py-5">
        <div dangerouslySetInnerHTML={{ __html: details }}></div>
      </section>
            <Footer />
        </div>
    )
}

export default TermAndCondition
